<script lang="ts" setup>
import type { PropType} from 'vue';
import { onMounted, ref } from 'vue';
import type { ICellRendererParams } from 'ag-grid-community';
import type { BadgeVariant } from '@/components/common/Badge.vue';

type ExtendedParams = ICellRendererParams & {
    id: string;
    title: (params: ICellRendererParams) => string;
    variant: (params: ICellRendererParams) => BadgeVariant;
    rounded?: (params: ICellRendererParams) => boolean;
    text?: (params: ICellRendererParams) => string;
    hidden?: (params: ICellRendererParams) => boolean;
    size?: (params: ICellRendererParams) => string;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = ref<string>('status');
const rounded = ref(false);
const text = ref<string>();
const variant = ref<BadgeVariant>('primary');
const hidden = ref<boolean>(false);
const size = ref<string>('default');

onMounted(() => {
    title.value = typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title;
    rounded.value = typeof props.params.rounded === 'function' ? props.params.rounded(props.params) : props.params.rounded ?? false;
    text.value = typeof props.params.text === 'function' ? props.params.text(props.params) : props.params.text;
    variant.value = typeof props.params.variant === 'function' ? props.params.variant(props.params) : props.params.variant;
    hidden.value = typeof props.params.hidden === 'function' ? props.params.hidden(props.params) : props.params.hidden ?? false;
    size.value = typeof props.params.size === 'function' ? props.params.size(props.params) : props.params.size ?? 'default';
});
</script>

<template>
    <div class="flex-container align-middle height-100 sy-spacer-x-3">
        <span v-if="text && !hidden" class="sy-type-bold">{{ text }}</span>
        <SBadge
            v-if="!hidden"
            :size="size"
            :variant="variant"
            :rounded="rounded"
        >
            {{ title }}
        </SBadge>
    </div>
</template>
